import { useState } from "react";
import { Route, Routes } from "react-router-dom";

import { MobileHeading } from "features/layout/components";
import { PRICING_PLANS } from "features/subscriptions/constants";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaces from "common/datahooks/useWorkspaces";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import AgencySubscriptionCard from "../../AgencySubscriptionCard";
import Invoices from "../../Invoices";
import PlanInvoicesToggle from "../../PlanInvoicesToggle";
import SettingsScrollContent from "../../SettingsScrollContent";
import AgencyLicenseSummary from "./AgencyLicenseSummary";
import DesktopTable from "./DesktopTable";
import MobileList from "./MobileLayout/MobileList";

interface PlanDetailsProps {
  onManageSubscription?: () => void;
}

export default function PlanDetails({
  onManageSubscription,
}: PlanDetailsProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { workspaces } = useWorkspaces();
  const { agency_subscription_status } = useSelectedWorkspaceContext();

  const [editingWorkspaceId, setEditingWorkspaceId] = useState<string>();

  const filteredWorkspaces = workspaces
    ? workspaces.filter(({ role }) => role === "owner")
    : [];

  const actionComponent = agency_subscription_status &&
    agency_subscription_status !== "cancelled" && (
      <PlanInvoicesToggle planLabel={PRICING_PLANS.agency.name} />
    );

  const Component = isDesktop ? DesktopTable : MobileList;

  return (
    <SettingsScrollContent desktopActionComponent={actionComponent}>
      {actionComponent && <MobileHeading actionComponent={actionComponent} />}
      <Routes>
        <Route
          path=""
          element={
            <>
              <AgencySubscriptionCard
                isAgencyPage
                onManageSubscription={onManageSubscription}
              />
              <AgencyLicenseSummary isCompact={false} />
              <Component
                workspaces={filteredWorkspaces}
                editingWorkspaceId={editingWorkspaceId}
                setEditingWorkspaceId={setEditingWorkspaceId}
              />
            </>
          }
        />
        <Route path="invoices" element={<Invoices type="agency" />} />
      </Routes>
    </SettingsScrollContent>
  );
}
